import React, {useEffect, useState} from 'react';
import {
    View,
    Text,
    StyleSheet,
    Dimensions,
    Platform,
    Pressable,
    TextInput
  } from 'react-native';
import logo from './logo';
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Button, Paper, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { FormInputText } from "./form-components/FormInputText";
import { FormInputDropdown } from "./form-components/FormInputDropdown";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PayloadItems from './payload-components/PayloadItems';
import PayloadEditor from './payload-components/PayloadEditor';
import Logout from './Logout';
import { jwtDecode } from "jwt-decode";
import "core-js/stable/atob";
import useToken from '../component/useToken';
import RecipientsResponses from './recipients-responses/RecipientsResponses';
import { ToastContainer, toast } from 'react-toastify';
import LookUpUser from './tiger-playground/LookUpUser';
import Cancellation from './tiger-playground/Cancellation';
import { Helmet } from 'react-helmet';



interface IFormInput {
    assignmentsValue: string;
    destinationValue: string;
    eventValue: string;
    roomValue: string;
    bedValue: string;
    csnValue: string;
    departmentValue: string;
    facilityValue:string;
    dateValue: Date;
  }
  const defaultValues = {
    assignmentsValue: "",
    destinationValue: "",
    eventValue: "",
    roomValue: "",
    bedValue: "",
    csnValue: "",
    departmentValue: "",
    facilityValue:"",
    dateValue: new Date()
  };

  const eventOptions = [
    {
      label: "Code Blue",
      value: "Code Blue",
    },
    {
      label: "Patient Call",
      value: "Patient Call",
    },
    {
      label: "Vent",
      value: "Vent",
    },
    {
      label: "Bed Out",
      value: "Bed Out",
    }
  ];

  const environtmentOptions = [
    {
      label: "PROD",
      value: "prod",
    },
    {
      label: "POC",
      value: "poc",
    } 
  ];
  
  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
  
  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
            <View style={{marginTop:10, padding:10}}>
                    {children}
          </View>
        )}
      </div>
    );
  }
  
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  var empty_payload={
    "message":"",
    "recipients":"",
    "emails":"",
    "message_type":"",
    "choices":"",
    "responselpp":"",
    "priority":"",
    "sound_type":"",
  }

const Home = () => {
    const { token, setToken } = useToken();
    const [valueTab, setValueTabs] = React.useState(0);
    const [dataPayload, setDataPayload] = useState({});
    const [epicdata,setEpicData]=useState("");
    const [templatedata, setTemplateData]= useState({});
    const [isTemplate, setIsTemplate]=useState(false);
    const [isEpic,setIsEpic]= useState(false);
    const [isEpicError, setIsEpicError]=useState(false);
    const [isSubmit,setIsSubmit]=useState(false);
    const [user, setUser]= useState("");
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    const [dim, setDim] = useState([
        Dimensions.get('window').width,
        Dimensions.get('window').height,
        Dimensions.get('window').width > Dimensions.get('window').height,
      ]);
    let onLayout = (e: any) => {
        setDim([e.nativeEvent.layout.width, e.nativeEvent.layout.height]);
      };
      const isDesktop = dim[0] > 1224;
      const isSmall = dim[0] < 700;
      const { handleSubmit, reset, control, setValue } = useForm<IFormInput>({
        defaultValues: defaultValues,
      });
      const onSubmit = (data: IFormInput) => {
       // console.log(data);
        if(data.destinationValue===""){
           // console.log("data.destinationValue..",data.destinationValue);
            //alert('Please select PROD or POC');
            toast.error('🦄 Please select PROD or POC', {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              });
        }
        else if(data.eventValue===""){
           // alert('Please select an event');
            toast.error('🦄 Please select an event', {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              });
        }
        else{
            try{

            fetch('https://ip-test.teleport.umms.org/codebluerequest', {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                  'Content-Type': 'application/json'
                }
              }).then(res => res.json())
              .then(response =>{
              //  console.log("data..."+JSON.stringify(response)); 
               if(response.result === "OK" && response.data !==""){
                    if(response.data.ReturnArray !==undefined){
                      var error_payload={
                        "message":response.data.ReturnArray[0],
                      
                      }
                      setEpicData(JSON.stringify(error_payload));
                      setIsEpic(false);
                      setIsEpicError(false);
                    }
                    else{
                      setEpicData(JSON.stringify(response.data));
                      setIsEpic(true);
                      setIsEpicError(true);
                    }
               
               }
               else{
                setEpicData(JSON.stringify(empty_payload));
                setIsEpic(false);
                setIsEpicError(false);
               }
               


              });
            }
            catch(err){
                console.log(err);
            }
        }
    };
    
    useEffect(()=>{
        if(!token) {
           window.location.reload();
        }
        else{

        setInterval(()=>{
            const { exp }:any = jwtDecode(token);
           // console.log("exp:", exp);
            
            const expirationTime = (exp * 1000);
           
            if (Date.now() > expirationTime) {
            
                //console.log("expired:",Date.now());
                localStorage.removeItem('token');
                Object.keys(localStorage).forEach(function(key){
                  if(key.indexOf("workflow")>-1){
                    localStorage.removeItem(key);
                  }
                });

                Object.keys(localStorage).forEach(function(key){
                  if(key.indexOf("codeblue")>-1){
                    localStorage.removeItem(key);
                  }
                });


                window.location.reload();
            }
        },1800000);
      
        }
    },[token,Date.now()]);

    const handleTemplate=()=>{
      setIsTemplate(true);
      setDataPayload(PayloadItems.sample_payload);

    };

    const handleEpic=()=>{
      setIsEpic(true);
      setDataPayload(JSON.parse(epicdata));
    };
    
    const changeEpicPayload=(edata:any)=>{
         //console.log(edata);
         if(edata !==""){
          setEpicData(edata);
          setIsEpic(true);
          setIsEpicError(true);
         }
         else{
          setEpicData("");
          setIsEpic(false);
          setIsEpicError(false);
         }
    };

 
    
    return (
        <div className="App">
          
             <ToastContainer />
            <View  onLayout={onLayout}>
             <header className="App-header">
                <img src={logo.img} className="App-logo" alt="logo" />
                <Logout/>
            </header>
          <section className="App-content">
               <View style={Platform.OS === 'web' && isDesktop ? style.content: style.contentMobile}>
                  <View style={style.leftBox}>
                    <View style={style.leftHeader}>
                        <Text style={{color:'#fff',  fontSize:19}}> CODE BLUE REQUEST</Text>
                        <View style={{width:150}}>
                        <FormInputDropdown 
                        name="destinationValue"
                        control={control}
                        label="Destination"
                        options={environtmentOptions}
                        backColor={"#cfe7ff"}
                    />
                        </View>
                       
                    </View>
                    <View style={style.leftContent}>
                        <View style={{width:200, alignSelf:'flex-start', marginRight:20, marginTop:20}}>
                       
                        <FormInputDropdown
                        name="eventValue"
                        control={control}
                        label="Event"
                        options={eventOptions}
                        backColor={"#fff"}
                    />
                    </View>
                    <View style={{ marginRight:20, marginTop:30, flexDirection:'row', justifyContent:'space-around'}}>
                        <FormInputText name="roomValue" control={control} label="Room" />
                        <FormInputText name="bedValue" control={control} label="Bed" />
                    </View>
                    <View style={{ marginRight:20, marginTop:20, flexDirection:'row', justifyContent:'space-around'}}>
                      <FormInputText name="csnValue" control={control} label="CSN" />
                      <FormInputText name="departmentValue" control={control} label="Department" /> 
                   </View>
                   <View style={{ marginRight:20, marginTop:20, flexDirection:'row', justifyContent:'space-around'}}>
                        <FormInputText name="facilityValue" control={control} label="Facility" />
                        <FormInputText name="assignmentsValue" control={control} label="Assignments" /> 
                   </View>
                    <View style={{ marginRight:20, marginTop:40, flexDirection:'row', justifyContent:'center'}}>
                        <Button onClick={handleSubmit(onSubmit)} variant={"contained"}>
                                Submit
                            </Button><span style={{paddingLeft:30}}>&nbsp;</span>
                            <Button onClick={() => reset()} variant={"outlined"}>
                                Reset
                            </Button>
                        </View>
                    
                    </View>
                  </View>
                  <View style={style.rightBox}>
                  <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={valueTab} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="EPIC Response" {...a11yProps(0)} />
                        <Tab label="Recipients Actions" {...a11yProps(1)} /> 
                        <Tab label="Look Up Recipient" {...a11yProps(2)} /> 
                        <Tab label="Code blue Cancellation" {...a11yProps(3)} /> 
                         
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={valueTab} index={0}>
                        <View style={{backgroundColor:'#bad2ec',  padding:20, flexDirection:'row', justifyContent:'center', width:'100%'}}>
                          <View style={{flexDirection:'column',justifyContent:'flex-start', width:'48%'}}>
                              <View style={{flexDirection:'row',justifyContent:'flex-start'}}> 
                                <Text style={{fontSize:12, fontWeight:'bold', minWidth:150}}>EPIC PAYLOAD</Text>
                                {isEpicError === true ? <Pressable onPress={handleEpic} style={{ marginTop:-14, borderRadius:10, backgroundColor:'blue', width:120, height:25, justifyContent:'center'}}><Text style={{color:'#fff', textAlign:'center', padding:5}}>use epic</Text></Pressable>:<></>}
                                
                              </View>
                              <TextInput multiline
                      numberOfLines={4}
                      style={{borderWidth:3,height:200,  maxHeight:500, padding:10, backgroundColor:'#fff'}}
                      maxLength={5000}  value={epicdata} onChangeText={e =>changeEpicPayload(e)}
                      onKeyPress={({ nativeEvent }) => {
                        if (nativeEvent.key === 'Backspace') {
                          setEpicData("");
                          setIsEpic(false);
                            setIsEpicError(false);
                        }
                      }}
                      />
                            
                            </View>
                          <View style={{marginLeft:10,width:'48%'}}>
                              <View style={{flexDirection:'row',justifyContent:'flex-start'}}> 
                                <Text style={{fontSize:12,fontWeight:'bold', minWidth:150}}>TEMPLATE PAYLOAD</Text>
                                <Pressable  onPress={handleTemplate} style={{ marginTop:-14, borderRadius:10,  backgroundColor:'blue', width:120, height:25, justifyContent:'center'}}><Text style={{color:'#fff', textAlign:'center', padding:5}}>use template</Text></Pressable>
                              </View>
                              <TextInput multiline
                      numberOfLines={4}
                      style={{borderWidth:3,height:200,  maxHeight:500, padding:10, backgroundColor:'#fff'}}
                      maxLength={5000}  value={JSON.stringify(PayloadItems.sample_payload)}
                     
                      />
                            </View>
                      </View>
                      <View style={{flexDirection:'column', padding:5, height:'auto'}}>
                          {dataPayload && (<PayloadEditor setIsSubmit={setIsSubmit} setValueTabs={setValueTabs} data={dataPayload} isEpic={isEpic} isTemplate={isTemplate} setIsTemplate={setIsTemplate} setIsEpic={setIsEpic}/>)} 
                         
                      </View>
                    </CustomTabPanel>
                    <CustomTabPanel value={valueTab} index={1}>
                       <RecipientsResponses  isSubmit={isSubmit} setValueTabs={setValueTabs} setUser={setUser}/>
                    </CustomTabPanel>

                    <CustomTabPanel value={valueTab} index={2}>
                       <LookUpUser user={user}/>
                    </CustomTabPanel>
                    
                    <CustomTabPanel value={valueTab} index={3}>
                       <Cancellation />
                    </CustomTabPanel>
                 </Box>
                  </View>

               </View>
        </section>
        </View>
      
      </div>
      );

}
const style = StyleSheet.create({
    textHeader:{
        color:'white', position:'absolute', marginLeft:'70%', fontSize:'1.2em'
      },
      content: {
        flexDirection: 'row',
        width:'100%',
        minWidth:600,
        borderRadius:10,
        borderColor:'#000',
        marginTop:20,
        },
      
      contentMobile:{
       flexDirection: 'column',
       alignSelf:'center',
       width:'100%',
        minWidth:400,
        borderRadius:5,
        borderColor:'#000',
        marginTop:20,
        justifyContent:'space-around'
      },
      leftHeader:{
        width:'100%',
        height:60,
        color:'#fff',
        justifyContent:'space-evenly',
        alignItems:'center',
        backgroundColor:'#0088f2',
        borderBottomColor:'#000',
        marginTop:60,
        borderTopLeftRadius:10,
        borderTopRightRadius:10,
        flexDirection:'row'
      },
      leftContent:{
        width:'100%',
        height:'100%',
        color:'#000',
        borderRadius:10,
        padding:5,
        textAlign:'justify',
        marginLeft:10,
        paddingTop:20
      },
      leftBox:{
        bottom:10,
        minHeight:450,
        height:'40%',
        maxWidth:435,
        width:'30%',
        backgroundColor:'#ffffff',
        flexDirection: 'column',
        flex:1,
        justifyContent:'center',
        borderRadius:10,
        marginLeft:20,
      
       // borderColor:'#000',
        //borderWidth:1,
    },
    rightBox:{
        marginLeft:10,
        bottom:10,
        minHeight:500,
        height:'100%',
        width:'73%',
        backgroundColor:'#ffffff',
        flexDirection: 'column',
        borderRadius:10
    },
})

export default Home;